export const SEARCH = "search";
export const CUSTOMER = 'customer';
export const USER_BASE = 'user-service/users';
export const USER_Detail = 'users/details';
export const AUTH_REFRESH = 'auth/refresh-token';
export const AUTH_INVALIDATE = 'auth/invalidate-token';
export const USER_LOGIN_DETAILS_SAVE = 'user/login/details/save';